import React, {useMemo} from 'react';
import styled from 'styled-components';
import CustomTable from '@ey/canvascoreservices/CustomTable';
import {labels} from '../../../util/utils';
import utilityfunctions from '../../../util/utilityfunctions';

function CommonAdminTable(props) {
	const {columns, tableClassName, items, sortConfig, paginationConfig} = props.config;

	const tableComponent = useMemo(()=> {
		return (
			<>
				<CustomTable
				columns={columns}
				className={tableClassName}
				items={items}
				showAccordions={false}
				hoverShadow={false}
				showNoResultFoundMessage={false}
				theme={utilityfunctions.getMotifTheme()}
				noResultFoundMessage={<span className="empty-container">{labels.noResultFound}</span>}
				searchConfig={{
					disabled: true
				}}
				sortConfig={sortConfig}
				paginationConfig={
					paginationConfig
						? paginationConfig
						: {
								disabled: items.length > 20 ? false : true,
								currentPage: 1,
								pageSize: 20,
								option: [20],
								showMoreLabel: '',
								firstButtonProps: labels.firstPage,
								lastButtonProps: labels.lastPage,
								prevButtonProps: labels.prevPage,
								nextButtonProps: labels.nextPage
						  }
				}
			/>
			</>
		)
	}, [props.config])
	return (
		<StyledTable>
			{tableComponent}
		</StyledTable>
	);
}

export default CommonAdminTable;

const StyledTable = styled.div`
	.show-more-label,
	.motif-pagination .motif-dropdown-trigger {
		visibility: hidden;
	}
`;
